import React from 'react'
import { observer } from 'mobx-react-lite'
import { endOfToday } from 'date-fns/endOfToday'
import { startOfToday } from 'date-fns/startOfToday'
import { subDays } from 'date-fns/subDays'

import {
  Loader,
  MiniWidgetContainer,
  useGlobalCopyStore,
  useGlobalUiStore,
  useRecurringTransactionsStore,
  useTransactionStore,
  useWidgetLoadTimer,
} from '../common'
import { type MiniWidgetProps } from '../core'

import { MiniWidgetContent } from './components/MiniWidgetContent'
import { RecurringTransactionDetailsDrawer } from './components/RecurringTransactionDetailsDrawer'
import { SkeletonLoader } from '../common/components/SkeletonLoader'

export const RecurringTransactionsMiniWidget = observer(
  ({ onPrimaryCtaClick, sx }: MiniWidgetProps) => {
    const { recurring: copy } = useGlobalCopyStore()
    const { setFilter } = useTransactionStore()
    const { isDataLoaded, loadRepeatingTransactionData } = useRecurringTransactionsStore()
    const { isInitialized, selectedAccountGuids } = useGlobalUiStore()

    useWidgetLoadTimer({
      widgetName: 'RecurringTransactionsMiniWidget',
      isLoaded: isDataLoaded,
    })

    React.useEffect(() => {
      if (!isDataLoaded) {
        loadRepeatingTransactionData().finally()
      }
    }, [])

    React.useEffect(() => {
      if (selectedAccountGuids.length > 0) {
        setFilter({
          dateRange: { start: subDays(startOfToday(), 90), end: endOfToday() },
          accounts: selectedAccountGuids,
        })
      }
    }, [selectedAccountGuids])

    if (!isInitialized) return <Loader />

    return (
      <MiniWidgetContainer
        className="mx-exp-recurring-transactions-miniwidget"
        onPrimaryCtaClick={onPrimaryCtaClick}
        primaryCtaLabel={copy.primary_cta}
        primaryCtaLabelAria={copy.primary_cta_aria}
        subTitle={copy.sub_title}
        sx={sx}
        title={copy.mini_title}
      >
        {isDataLoaded ? <MiniWidgetContent /> : <SkeletonLoader sx={{ mx: 16 }} variant="list" />}

        <RecurringTransactionDetailsDrawer />
      </MiniWidgetContainer>
    )
  },
)
